export function titleCase(value: string) {
  if (!value) {
    return "";
  }
  return value.charAt(0).toLocaleUpperCase() + value.substring(1);
}
